import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import WizardInput from 'components/wizard/WizardInput';
import { Button, Col, Row } from 'react-bootstrap';
import { MdHorizontalRule } from 'react-icons/md';

const InformationsSupplementaires = ({
  register,
  errors,
  setValue,
  watch,
  unregister
}) => {
  // const { user } = useAuthWizardContext();
  const [telephones, setTelephones] = useState(watch('telephones') || []);
  const [adresses, setAdresses] = useState(watch('adresses') || []);

  useEffect(() => {
    console.log('Updated errors:', errors);
  }, [errors]);

  return (
    <>
      <div>
        <h5>Téléphones</h5>

        {telephones.map((telephone, index) => (
          <Row key={index}>
            <Col md="auto">
              <WizardInput
                key={index}
                label="Téléphone"
                name={`telephones.${index}`} // Matches the key used in register
                errors={errors}
                formGroupProps={{ className: 'mb-3 mt-3' }}
                formControlProps={{
                  ...register(`telephones.${index}`, {
                    required: 'Telephone est obligatoire',
                    minLength: {
                      value: 8,
                      message: "Nom de l'entreprise est obligatoire"
                    }
                  })
                }}
              />
            </Col>
            <Col className="d-flex align-items-center pt-4">
              <Button
                variant="danger"
                onClick={() => {
                  // Unregister the field for the removed item
                  unregister(`telephones.${index}`);

                  // Update the telephones array
                  const updatedTelephones = [
                    ...telephones.slice(0, index),
                    ...telephones.slice(index + 1)
                  ];
                  setTelephones(updatedTelephones);

                  // Update the form values in React Hook Form
                  setValue('telephones', updatedTelephones);
                }}
              >
                <MdHorizontalRule className="fw-bold" />
              </Button>
            </Col>
          </Row>
        ))}

        <Button
          style={{ fontSize: '12px', marginTop: '10px' }}
          onClick={() => setTelephones([...telephones, ''])}
        >
          Avez-vous un numéro de téléphone?
        </Button>
      </div>
      <div>
        <h5 className="mt-3 mb-0">Adresses</h5>
        {adresses.map((adresse, index) => (
          <Row key={index} className="mt-0">
            <Col md="auto">
              <WizardInput
                key={index}
                label="Adresse"
                name={`adresse.${index}`} // Matches the key used in register
                errors={errors}
                formGroupProps={{ className: 'mb-3 mt-3' }}
                formControlProps={{
                  ...register(`adresse.${index}`)
                }}
              />
            </Col>
            <Col className="d-flex align-items-center pt-4">
              <Button
                variant="danger"
                onClick={() => {
                  setAdresses([
                    ...adresses.slice(0, index),
                    ...adresses.slice(index + 1)
                  ]);
                  setValue('adresses', [
                    ...adresses.slice(0, index),
                    ...adresses.slice(index + 1)
                  ]);
                }}
              >
                <MdHorizontalRule className="fw-bold" />
              </Button>
            </Col>
          </Row>
        ))}

        <Button
          style={{ fontSize: '12px', marginTop: '10px' }}
          onClick={() => setAdresses([...adresses, ''])}
        >
          Avez-vous un numéro de téléphone?
        </Button>
      </div>
    </>
  );
};

InformationsSupplementaires.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  unregister: PropTypes.func,
  watch: PropTypes.func
};

export default InformationsSupplementaires;
